import { Outlet, useLocation } from 'react-router-dom'
import { Header, Segment } from 'semantic-ui-react'
import SecondaryMenu from '../../components/SecondaryMenu'
import { selectBurstIsLive, selectFluxIsLive } from '../../store/fluxLiveSlice'
import { useAppSelector } from '../../store/hooks'
import { useLiveStatusWebSocket } from '../../store/useLiveStatusWebSocket'
import Layout from '../Layout'
import './MainView.scss'

function MainView() {
  const location = useLocation()
  const isFluxLive = useAppSelector(selectFluxIsLive)
  const isBurstLive = useAppSelector(selectBurstIsLive)

  // Maintain WebSocket connections for live status tracking across all tabs
  useLiveStatusWebSocket()

  return (
    <Layout>
      <div className='main_view_header'>
        <Header as='h1'>ROSIE</Header>
        <Header as='h3' id='main_view_header_description'>
          Explore data
        </Header>
      </div>

      <div className='main_view_body'>
        <div className='left_panel'>
          <SecondaryMenu
            items={[
              {
                name: (
                  <span className='live-menu-item'>
                    Solar Flux
                    {isFluxLive && (
                      <span className='live-indicator'>
                        <span className='dot'></span> LIVE
                      </span>
                    )}
                  </span>
                ),
                link: '',
                icon: 'sun',
              },
              {
                name: 'Solar Indices',
                link: 'SolarIndexes',
                icon: 'note',
              },
              {
                name: (
                  <span className='live-menu-item'>
                    Radio Spectrograms
                    {isBurstLive && (
                      <span className='live-indicator'>
                        <span className='dot'></span> LIVE
                      </span>
                    )}
                  </span>
                ),
                link: 'radioSpectrogram',
                icon: 'note',
              },
              {
                name: 'Data archive',
                link: 'archival',
                icon: 'calendar',
              },
            ]}
            activeItem={location.pathname.split('/')[1]}
          />
        </div>

        <Segment className='right_panel'>
          <Outlet />
        </Segment>
      </div>
    </Layout>
  )
}

export default MainView
